module.exports = __webpack_public_path__ + "static/media/seeuletter.8c6e8345.jpg";